import AttendancesList from "@/views/attendances_list/index.vue";

import DefaultLayout from "@/views/layouts/default.vue";

export default [
  {
    path: "/atendimentos",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "Atendimentos",
        component: AttendancesList,
      },
    ],
  },
];
